/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";

// Import icons for edit and delete actions
import edit_logo from "../../../../icons/edit.png";
import tash_logo from "../../../../icons/trash.png";

// The Tr component represents a single row in the table for displaying approved names
export default function Tr({
  id, // ID of the approved name
  approved_name, // Name of the approved item
  art_pack_id, // Associated art pack ID
  display_order, // The display order for the approved name
  onEdit, // Callback function to handle editing the record
  onDelete, // Callback function to handle deleting the record
  isAllowedToEditOrDelete, // Boolean to check if editing/deleting is permitted
}) {
  return (
    <>
      <tr>
        {/* Display the approved name */}
        <td className="ps-5">
          <span className="extra_space_3">{approved_name}</span>
        </td>
        {/* Display Order */}
        <td className="col-numeric-date">{display_order}</td>
        <td className="col-options">
          {/* Edit icon with conditional click handling */}
          <a
            onClick={(e) => {
              // If editing is allowed, call onEdit; otherwise, prevent default action
              isAllowedToEditOrDelete
                ? onEdit({
                  id,
                  approved_name,
                  art_pack_id,
                  display_order,
                })
                : e.preventDefault();
            }}
            // Change cursor style based on permission
            style={{
              cursor: isAllowedToEditOrDelete ? "pointer" : "not-allowed",
            }}
          >
            <img className="edit-delete-icons" src={edit_logo} alt="Edit" />
          </a>
          &nbsp;
          {/* Delete icon with conditional click handling */}
          <a
            onClick={(e) => {
              // If deleting is allowed, call onDelete; otherwise, prevent default action
              isAllowedToEditOrDelete
                ? onDelete({
                  id,
                  approved_name,
                  art_pack_id,
                  display_order,
                  delete: true,
                })
                : e.preventDefault();
            }}
            // Change cursor style based on permission
            style={{
              cursor: isAllowedToEditOrDelete ? "pointer" : "not-allowed",
            }}
          >
            <img
              className="edit-delete-icons ms-3"
              src={tash_logo}
              alt="Delete"
            />
          </a>
          &nbsp;
        </td>
      </tr>
    </>
  );
}
